import { render, staticRenderFns } from "./QualificationDetailsForm.vue?vue&type=template&id=3bf51c5d&"
import script from "./QualificationDetailsForm.vue?vue&type=script&lang=js&"
export * from "./QualificationDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./QualificationDetailsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VLabel,VRow,VTextField})
